module.exports = __webpack_public_path__ + "img/logo-vitalliance-2026.7e0d3dbe.svg";